import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import Attribute from "views/Accounts/PersonDetails/Attribute";
import "views/Accounts/PersonDetails/personProfileStyle.css";
import { putPersonData, getLabels } from "api/AccountsApi";
import { Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import { Contacts } from "@material-ui/icons";
import { getCompanySettings, putCompanySettings, getStates,getStripeLink } from 'api/SettingsApi'
import { ReactComponent as Icon } from "assets/img/info.svg"
import SupportLink from "../Common/SupportLink";
// import { loadStripe ,Stripe} from "@stripe/stripe-js";
import moment from "moment";
import { setCompanyLevelComplaiceFlag } from "ReduxStore/Slices/userSlice";

import {
    getCompany,
} from "api/AccountsApi";
import AddCardModal from "./AddCardModal";
import AddBankModal from "./AddBankModal";

import { useSelector, useDispatch } from "react-redux";

import { GET ,POST } from "api/API";


const createOption = (label) => ({
    label,
    value: label.toLowerCase().replace(/\W/g, ""),
    status: null
});
const DealDetail = (props) => {

    const dispatch = useDispatch();

    const { role } = useSelector(state => state.userSetter)



    const [companyName, setCompanyName] = useState("");

    const [s1, setS1] = useState(-10);
    const [isLoading, setIsLoading] = useState(false);
    const [compliance, setComplaice] = useState({ value: false });
    // const [referral, setReferral] = useState({ value: false });
    // const [lead, setLead] = useState({ value: false });

    //const [campaigns, setCampaigns] = useState([{label: 'Campaign',value: 'eee'}])

    //  only values
    const [prospect, SetProspect] = useState({ value: false });
    const [supscription, setSubscribtion] = useState('');
    const [sms, setSms] = useState('');
    const [dkim, setDkim] = useState('');


    const [leadGenDiscount, setLeadGenDiscount] = useState('');

    const [monthlySpendLimit, setmonthlySpendLimit] = useState({ value: null });






    // multiple values
    const [whitelist, setWhitelist] = useState([])
    const [campaignEmails, setCampaignEmails] = useState([])
    const [address, setAddress] = useState({ value: '' })
    const [description, setDescription] = useState({ value: '' })

    const [campaignsId, setCampaignsId] = useState(null)
    const [states, setStates] = useState([])
    const [Allstates, setAllStates] = useState([])
    const [statemeta, setStateMeta] = useState("")
    const [showCardModal, setShowCardModal] = useState(false)
    const [showBankModal, setShowBankModal] = useState(false)

    const [investableIncomeRange, setinvestableIncomeRange] = useState([])
    const [AllinvestableIncomeRange, setAllinvestableIncomeRange] = useState([{ label: "Less than 100K", value: "Less than 100K" }, { label: "100 - 200K", value: "100 - 200K" },  { label: "200 - 300K", value: "200 - 300K" }, { label: "300 - 500K", value: "300 - 500K" }, { label: "500K - 1.0M", value: "500K - 1.0M" },{ label: "1.0M- 2.0M", value: "1.0M- 2.0M" }, { label: "Above 2.0M", value: "Above 2.0M" }])
    const [preferredWorkLocation, setpreferredWorkLocation] = useState({ value: '' })

    const [investMeta, setInvestMeta] = useState("")


    const [card, setCard] = useState("")

    const [bank , setBank] = useState("")


    const customStyles = {
        control: base => ({
            ...base,
            border: 0,
            boxShadow: 'none',
        })

    }

    function AddCard() {
        setShowCardModal(true)
    }

    function AddBank() {
        getStripeLink().then((res) => {
        console.log(res)
        window.open(res.url, "_blank")
        })

    }

    useEffect(() => {
        getCompany()
            .then((data) => {
                setCompanyName(data.name);
            })
            .catch((e) => { })

        getStates()
            .then(data => {

                let map = {}

                data.forEach(d => {
                    map[d.id] = d.name
                })
                console.log(map)
                setAllStates(data.map(d => { return { label: d.name, value: d.id } }))

                getCompanySettings()
                    .then((data) => {


                        let e = data.settings.find(e => e.metadata.key == 'investableIncomeRange')
                        console.log("investableIncomeRange", e)
                        if (e.value && e.value.length) {
                            console.log("investableIncomeRange", e.value)
                            setinvestableIncomeRange(e.value.map(d => { return { label: d, value: d } }))
                        }

                        if (data.cards.length) {
                            setCard(data.cards[0].cardBrand + "   **** **** **** " + data.cards[0].cardLast4)
                        }

                        if (data.bank){
                            // setBank(data.bank)
                        }

                        let domains = data.whiteListDomains.map(d => { return { label: d.domainName, value: d.id } })
                        setWhitelist(domains)






                        console.log("data", data)
                        console.log("monthlySpendLimit", data.settings.find(e => e.metadata.key == 'monthlySpendLimit'))

                        setmonthlySpendLimit({ value: data.settings.find(e => e.metadata.key == 'monthlySpendLimit').value, id: data.settings.find(e => e.metadata.key == 'monthlySpendLimit').metadata.id })
                        setpreferredWorkLocation({ value: data.settings.find(e => e.metadata.key == 'preferredWorkLocation').value, id: data.settings.find(e => e.metadata.key == 'preferredWorkLocation').metadata.id })

                        data.settings.forEach(e => {
                            if (e.metadata.key.trim() == 'campaignEmail') {
                                let emails = e.value
                                emails = emails.map(email => { return { label: email.email, value: email.email, status: email.status } })
                                setCampaignEmails([...emails])
                                setCampaignsId(e.metadata.id)

                            }
                            // if (e.metadata.key == 'monthlySpendLimit') {
                            //     console.log("monthlySpendLimit",e.value , e.metadata.id)

                            // }

                            if (e.metadata.key == 'compliance') {
                                setComplaice({ value: e.value, id: e.metadata.id })
                            }
                            // if (e.metadata.key == 'referral') {
                            //     setReferral({ value: e.value, id: e.metadata.id })
                            // }
                            if (e.metadata.key == 'prospectPopup') {
                                SetProspect({ value: e.value, id: e.metadata.id })
                            }
                            if (e.metadata.key == 'subscriptionPlan') {
                                let date = moment(e.value.endsOn).format('MM/DD/YYYY');
                                setSubscribtion(date)
                            }
                            if (e.metadata.key == 'dkim') {
                                setDkim(e.value)
                            }
                            if (e.metadata.key == 'sms') {
                                setSms(e.value)

                            }
                            if (e.metadata.key == 'address') {
                                setAddress({ value: e.value })
                            }
                            if (e.metadata.key == 'description') {
                                setDescription({ value: e.value, id: e.metadata.id })
                            }


                            // if (e.metadata.key == 'preferredWorkLocation') {
                            //     console.log("preferredWorkLocation",e.value , e.metadata.id)
                            //     setpreferredWorkLocation({ value: e.value , id : e.metadata.id })
                            // }


                            if (e.metadata.key == 'leadGenDiscount') {
                                setLeadGenDiscount(e.value)
                            }

                            if (e.metadata.key == 'investableIncomeRange') {
                                // setinvestableIncomeRange({ value: e.value , id : e.metadata.id })
                                setInvestMeta(e.metadata.id)
                                console.log("investableIncomeRange", e.value, e.metadata.id)


                            }




                            if (e.metadata.key == 'stateList') {
                                setStateMeta(e.metadata.id)
                                if (e.value) {
                                    setStates(e.value.map(d => { return { label: map[d], value: d } }))
                                }
                            }
                        });


                    })
                    .catch((e) => { })



            })

            GET('company/settings/stripeAccount').then(data=>{
                console.log("rrrrrrttttttttt",data)
                if(data){
                    let x = data && data.external_accounts  && data.external_accounts.data && data.external_accounts.data.length &&  data.external_accounts.data[0]?.last4
                    if (x) setBank({accountNo: x})

                    console.log(x)
                }
            })



    }, []);

    let i = 0;
    const attr = (label, value, type) => {
        if (type === 'select')
            i++;

        return < div
            style={{
                display: "flex",
                flexDirection: "column",
                margin: "5px",
                paddingBottom: "20px",
            }
            }
        >
            <div style={s1 == i ? { width: "100%", display: 'flex' ,flexDirection: "column", zIndex: 70002 } : { width: "100%", display: 'flex' ,flexDirection: "column" }} >
                <span style={{ flex: 0.7 }} className="attributeLabel">{label}</span>

                <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                    <span
                        className="attributeLabel"
                        style={{ marginTop: "9px", }}
                    >
                        
                    </span>
                    

                    {type == 'text' && <div className="attributeValue " >
                        <div dangerouslySetInnerHTML={{ __html: value }}>
                        </div>
                    </div>}
                    {type == "select" && <div style={{ width: '100%' }}>

                        {s1 == i && <div id={'pop' + i} className="userguide-popup " > lorem ipsum dolor sit amet, consectetur adip</div>}
                    </div>

                    }
                    {type != "text" && type != 'select' && <input
                        type={'checkbox'}
                        style={{
                            border: "1px solid #5F5F6A",
                            padding: "7px",
                            borderRadius: "5px",
                            height: '23px',
                            backgroundColor: "#fff", marginLeft: "12px"
                        }} className=" " />
                    }
                </div>
            </div>
        </div >

    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const nameWithEmailValidation = (email) => {
        let e = ''
        if (email.includes('<' || '>')) {
            for (let i = 0; i < email.length; i++) {
                if (email[i] === '<' && email[email.length - 1] === '>' && (email[0] !== '<' || email[0] !== '>')) {
                    e = email.slice(i + 1, email.length - 1)
                }
            }
            return validateEmail(e)
        } else {
            return validateEmail(email)
        }
    }

    const handleChange = (newValue, actionMeta) => {
        setCampaignEmails(newValue);
    };
    const handleCreate = (inputValue) => {
        setIsLoading(true);
        setTimeout(() => {
            const newOption = createOption(inputValue);
            if (nameWithEmailValidation(inputValue)) {
                setCampaignEmails([...campaignEmails, newOption]);
                setIsLoading(false);
            } else {
                toast.error('Please enter valid email')
                setIsLoading(false);
            }

        }, 1000);
    };
    const handleChange1 = (newValue, actionMeta) => {
        setWhitelist(newValue);
    };
    const handleChange2 = (newValue, actionMeta) => {
        setStates(newValue);
    };
    const handleChange5 = (newValue, actionMeta) => {
        setinvestableIncomeRange(newValue);
    };
    const handleCreate1 = (inputValue) => {
        setIsLoading(true);
        console.group("Option created");

        setTimeout(() => {
            const newOption = createOption(inputValue);
            setWhitelist([...whitelist, newOption]);
            setIsLoading(false);
        }, 1000);
    };
    const handleCreate2 = (inputValue) => {
        setIsLoading(true);
        console.group("Option created");

        setTimeout(() => {
            const newOption = createOption(inputValue);
            setStates([...states, newOption]);
            setIsLoading(false);
        }, 1000);
    };

    const handleCreate5 = (inputValue) => {
        setIsLoading(true);
        console.group("Option created");

        setTimeout(() => {
            const newOption = createOption(inputValue);
            setinvestableIncomeRange([...investableIncomeRange, newOption]);
            setIsLoading(false);
        }, 1000);
    };
    const update = () => {
        if (monthlySpendLimit.value && monthlySpendLimit.value < 500) {
            toast.error("Monthly spend limit should be greater than 500")
            return
        }


        let body = {
            settings: [
                {
                    metadataId: prospect.id,
                    value: prospect.value,
                },
                {
                    metadataId: compliance.id,
                    value: compliance.value,
                },
                // {
                //     metadataId: referral.id,
                //     value: referral.value,
                // },
                {
                    metadataId: campaignsId,
                    value: campaignEmails.map(e => { return { email: e.label, status: e.status } })
                },
                {
                    metadataId: statemeta,
                    value: states.map(e => e.value)
                },
                {
                    metadataId: description.id,
                    value: description.value,
                },
                {
                    metadataId: investMeta,
                    value: investableIncomeRange.map(e => e.value),
                },
                {
                    metadataId: preferredWorkLocation.id,
                    value: preferredWorkLocation.value,
                },
                {
                    metadataId: monthlySpendLimit.id,
                    value: monthlySpendLimit.value
                },

            ],
            whiteListDomains: whitelist.map(e => e.label),
            address: address.value,

        };
        
        dispatch(setCompanyLevelComplaiceFlag(compliance?.value ? true : false));

        putCompanySettings(body)
            .then((data) => {

                toast.success("Settings has been updated successfully");

            }).catch((err) => {
                toast.error("Something went wrong, please try again later");
            })

     

    }

    function handleClose(card) {
        if (card) {
            setCard(card)
        }
        setShowCardModal(false)
    }

    function handleCloseBank(bank) {
        console.log("bank", bank)
        if (bank) {
            setBank(bank)
        }
        setShowBankModal(false)
    }

    return (
        <>
            <SupportLink link='https://kapitalwise.com/user-guide/settings#org_setup' />

            <div id="p-container">
                <br />
                <br />

                <h2 className="p-title">General</h2>
                <p>{companyName}</p>


                <div class="h_line"></div>



                    < div
                        style={{
                            display: "flex",
                            flexDirection: "",
                            margin: "5px",
                            paddingBottom: "20px",
                            alignItems: "center"

                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >
                               <div style={{ marginTop: "9px", display: 'flex', width: '98%' , maxWidth:"70px"}}>
                                                 
                                                 <div style={{ width: '100%' }}>
                                                         <input
                                                             checked={compliance.value}
                                                             onChange={(e) => { let x = compliance; x.value = !x.value; setComplaice({ ...x }) }}
                                                             type={'checkbox'}
                                                             style={{
                                                                 border: "1px solid #5F5F6A",
                                                                 padding: "7px",
                                                                 borderRadius: "5px",
                                                                 height: '23px',
                                                                 backgroundColor: "#fff", marginLeft: "12px"
                                                             }} className=" " />
                                                     </div>
                                            
                                   
                                                 </div>
                     
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "row" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Enable Compliance Flow
                                <OverlayTrigger
                                    delay={{ hide: 650, show: 50 }}
                                    placement="top"
                                    key="top"
                                    overlay={(props) => (
                                        <Tooltip id="tooltip-top" {...props}>
                                            Compliance Flow let your compliance team review and approve the marketing content.&nbsp;
                                            <a href="https://www.kapitalwise.com/user-guide/settings#org_setup" target="_blank">
                                                Learn more.</a>
                                        </Tooltip>
                                    )}
                                >
                                    <span className="ml-2"><Icon /></span>
                                </OverlayTrigger>
                            </span>

                     
                        </div>

                    </div >
                <div className='config-grid'>

               

                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >

                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Lead-gen Monthly Spend Limit (USD)
                                <OverlayTrigger
                                    delay={{ hide: 650, show: 50 }}
                                    placement="top"
                                    key="top"
                                    overlay={(props) => (
                                        <Tooltip id="tooltip-top" {...props}>
                                            .&nbsp;
                                            <a href="https://www.kapitalwise.com/user-guide/settings#org_setup" target="_blank">
                                                Learn more.</a>
                                        </Tooltip>
                                    )}
                                >
                                    <span className="ml-2"><Icon /></span>
                                </OverlayTrigger>
                            </span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%'  }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%', position:"relative" }}>
                                    {monthlySpendLimit.value && <span  style={{ position:"absolute", top: "7px", left:"6px" }}>$</span>}

                                    <input
                                        value={monthlySpendLimit.value}
                                        onChange={(e) => { setmonthlySpendLimit({ ...monthlySpendLimit, value: e.target.value }) }}
                                        type={'number'}
                                        placeholder={monthlySpendLimit.value ? '' : 'Not set'}
                                        min={500}
                                        style={{
                                            border: "1px solid #5F5F6A",
                                            padding: "7px",
                                            borderRadius: "5px",
                                            // height: '23px',
                                            width: '100%',
                                            paddingLeft:"14px",
                                            position: 'relative',
                                            backgroundColor: "#fff"
                                        }} className="no-arcolumns" />
                                </div>
                            </div>

                        </div>
                    </div >




                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Campaign From Email
                                <OverlayTrigger
                                    delay={{ hide: 50, show: 50 }}
                                    placement="top"
                                    key="top"
                                    overlay={(props) => (
                                        <Tooltip id="tooltip-top" {...props}>
                                            Add additional emails for sending your marketing campaigns. New emails added would take up to 24hrs to be get verified.
                                        </Tooltip>
                                    )}
                                >
                                    <span className="ml-2" style={{ color: '#c3c3ce' }}><Icon /></span>
                                </OverlayTrigger>
                            </span>
                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={(val) => <span>Add {val}</span>}
                                        value={campaignEmails}
                                        placeholder={"Add.."}
                                        onChange={handleChange}
                                        onCreateOption={handleCreate}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div >
                    {/* Des Field */}
                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            gridColumn:'span 2'

                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Company Description
                            </span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <textarea
                                        onChange={(e) => {
                                            setDescription({ ...description, value: e.target.value })
                                        }}
                                        type={'text'}
                                        value={description.value}
                                        style={{
                                            border: "1px solid #5F5F6A",
                                            padding: "7px",
                                            borderRadius: "5px",
                                            width: '100%',
                                            backgroundColor: "#fff"
                                        }} className=" " />
                                </div>
                            </div>
                        </div>
                    </div >
                    {/* inv Field */}
                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            gridColumn:'span 2'
                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Investable Asset Range
                            </span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={(val) => undefined}
                                        // onChange={handleChangeTags}
                                        //onInputChange={handleInputChange}
                                        value={investableIncomeRange}
                                        // styles={customStyles}
                                        placeholder={"Add.."}
                                        onChange={handleChange5}
                                        onCreateOption={handleCreate5}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                        options={AllinvestableIncomeRange}
                                    />
                                    {/* <select
                                    
                                    onChange={(e) => {
                                        setinvestableIncomeRange({ ...investableIncomeRange, value: e.target.value })
                                    }}
                                    value={investableIncomeRange.value}

                                    style={{
                                        border: "1px solid #5F5F6A",
                                        padding: "7px",
                                        borderRadius: "5px",
                                        width: '100%',
                                        backgroundColor: "#fff"
                                    }}
                                    
                                    >
                                        <option value="-1">select</option>
                                        <option value="Less than 50K">Less than 50K</option>
                                        <option value="50 - 100K">50 - 100K</option>
                                        <option value="100 - 200K">100 - 200K</option>
                                        <option value="200 - 300K">200 - 300K</option>
                                        <option value="300 - 500K">300 - 500K</option>
                                        <option value="500K - 1.0M">500K - 1.0M</option>
                                        <option value="Above 1.0M">Above 1.0M</option>


                                    </select> */}

                                </div>
                            </div>
                        </div>
                    </div >
                    {/* inv2 Field */}
                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Preferred Work Location
                            </span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <select

                                        onChange={(e) => {
                                            setpreferredWorkLocation({ ...preferredWorkLocation, value: e.target.value })
                                        }}
                                        value={preferredWorkLocation.value}

                                        style={{
                                            border: "1px solid #5F5F6A",
                                            padding: "7px",
                                            borderRadius: "5px",
                                            width: '100%',
                                            backgroundColor: "#fff"
                                        }}

                                    >
                                        <option value="-1">select</option>
                                        <option value="Remote">Remote</option>
                                        <option value="In-person">In-person</option>

                                    </select>
                                </div>
                            </div>
                        </div>
                    </div >
                    {/* Address Field */}
                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">Address
                            </span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <input
                                        onChange={(e) => {
                                            setAddress({ ...address, value: e.target.value })
                                        }}
                                        type={'text'}
                                        value={address.value}
                                        style={{
                                            border: "1px solid #5F5F6A",
                                            padding: "7px",
                                            borderRadius: "5px",
                                            width: '100%',
                                            backgroundColor: "#fff"
                                        }} className=" " />
                                </div>
                            </div>
                        </div>
                    </div >

                    {attr(<>
                        <span>Text Messages</span>
                        <OverlayTrigger
                            delay={{ hide: 50, show: 50 }}
                            placement="top"
                            key="top"
                            overlay={(props) => (
                                <Tooltip id="tooltip-top" {...props}>
                                    Text message is not included in your current plan.
                                </Tooltip>
                            )}
                        >
                            <span className="ml-2"><Icon /></span>
                        </OverlayTrigger>
                    </>, sms, 'text')}

                    {attr(

                        <span>DKIM and SPF Setting
                            <OverlayTrigger
                                delay={{ hide: 650, show: 50 }}
                                placement="top"
                                key="top"
                                overlay={(props) => (
                                    <Tooltip id="tooltip-top" {...props}>
                                        DKIM and SPF settings help you improve email deliverability.&nbsp;
                                        <a href="https://www.kapitalwise.com/user-guide/miscellaneous" target="_blank">Learn more.</a>
                                    </Tooltip>
                                )}
                            >
                                <span className="ml-2"><Icon /></span>
                            </OverlayTrigger>
                        </span>
                        , dkim, 'text')}
                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">{`Subscription`}</span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                {supscription &&
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <div><span className='font-weight-bold'>Your current subscription ends on:</span><span className='ml-2'>{supscription}</span></div>
                                    </div>}

                            </div>
                        </div>
                    </div >

                    {/* < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >
                            <span style={{ flex: 0.7 }} className="attributeLabel">{`Lead Generation Discount`}</span>

                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    :
                                </span>
                                
                                {supscription &&
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <div><span className='font-weight-bold'>{leadGenDiscount || 0}%</span></div>
                                    </div>}

                            </div>
                        </div>
                    </div > */}


                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >

                            <span style={{ flex: 0.7 }} className="attributeLabel">{`Whitelisted Domains`}
                                <OverlayTrigger
                                    delay={{ hide: 650, show: 50 }}
                                    placement="top"
                                    key="top"
                                    overlay={(props) => (
                                        <Tooltip id="tooltip-top" {...props}>
                                            Web domains that would publish events to your Kapitalwise account. <a href="https://www.kapitalwise.com/user-guide/tags/" target="_blank">Learn more.</a>

                                        </Tooltip>
                                    )}
                                >
                                    <span className="ml-2"><Icon /></span>
                                </OverlayTrigger>
                            </span>


                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={(val) => <span>Add {val}</span>}
                                        // onChange={handleChangeTags}
                                        //onInputChange={handleInputChange}
                                        value={whitelist}
                                        // styles={customStyles}
                                        placeholder={"Add.."}
                                        onChange={handleChange1}
                                        onCreateOption={handleCreate1}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                    // options={campaigns}
                                    />
                                </div>
                            </div>
                        </div>
                    </div >






                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >

                            <span style={{ flex: 0.7 }} className="attributeLabel">{`States`}
                                <OverlayTrigger
                                    delay={{ hide: 650, show: 50 }}
                                    placement="top"
                                    key="top"
                                    overlay={(props) => (
                                        <Tooltip id="tooltip-top" {...props}>

                                        </Tooltip>
                                    )}
                                >
                                    <span className="ml-2"><Icon /></span>
                                </OverlayTrigger>
                            </span>


                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={(val) => undefined}
                                        // onChange={handleChangeTags}
                                        //onInputChange={handleInputChange}
                                        value={states}
                                        // styles={customStyles}
                                        placeholder={"Add.."}
                                        onChange={handleChange2}
                                        onCreateOption={handleCreate2}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                        options={Allstates}
                                    />
                                </div>
                            </div>
                        </div>
                    </div >


                    < div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            paddingBottom: "20px",
                            // ...{ gridColumnStart: 1, gridColumnEnd: 1, }

                        }
                        }
                    >
                        <div style={{ width: "100%", display: 'flex' ,flexDirection: "column" }} >

                            <span style={{ flex: 0.7 }} className="attributeLabel">{role=='publisher'? "Bank Account" : `Card Details`}
                                <OverlayTrigger
                                    delay={{ hide: 650, show: 50 }}
                                    placement="top"
                                    key="top"
                                    overlay={(props) => (
                                        <Tooltip id="tooltip-top" {...props}>
                                           {role=='publisher'?'Credit/Debit card details.': 'Bank Account'}  <a href="https://www.kapitalwise.com/user-guide/tags/" target="_blank">Learn more.</a>

                                        </Tooltip>
                                    )}
                                >
                                    <span className="ml-2"><Icon /></span>
                                </OverlayTrigger>
                            </span>


                            <div style={{ marginTop: "9px", display: 'flex', width: '98%' }}>
                                {showCardModal && <AddCardModal handleClose={handleClose} />}
                                {showBankModal && <AddBankModal handleClose={handleCloseBank} />}

                                <span
                                    className="attributeLabel"
                                    style={{ marginTop: "9px", }}
                                >
                                    
                                </span>
                                
                                <div style={{ width: '100%' }}>
                                    {(role == 'publisher' && bank) || (role != 'publisher' && card)  ? <div

                                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', flexFlow: 'column wrap' }}
                                    > <span className="font-weight-bold" style={{ textTransform: 'capitalize' }} >{ role=='publisher'?`Account No ending with: ${bank?.accountNo}`: card} </span>

                                        <a style={{ color: "#2c40ce" }} href="#" className="ml-2 font-weight-bold" onClick={role=='publisher'?AddBank: AddCard}>{role=='publisher'?'Modify Bank Details through Stripe ': 'Modify your payment method'}  </a>

                                    </div>

                                        :
                                        <a className="font-weight-bold" style={{ color: "#2c40ce" }} href="#" onClick={role=='publisher'?AddBank: AddCard}> {role=='publisher'?'Add Bank Details through Stripe ': 'Add a payment method'} </a>

                                    }

                                </div>
                            </div>
                        </div>
                    </div >















                </div>

                <div  className="ihwrow">
                    <input
                        type="submit"
                        name="Save"
                        style={{ cursor: "pointer" }}
                        className="lg_btn secondary mb-2"
                        id="profileSave"
                        value="SAVE"
                        onClick={() => update()}
                    />

                    <input
                        type="submit"
                        name="Save"
                        style={{ cursor: "pointer" }}
                        className="lg_btn secondary mb-2"
                        id="profileCancel"
                        value="Cancel"
                        onClick={() =>
                            props.history.push(`/admin/sales/deals`)
                        }
                    />
                </div>

            </div>
        </>
    );
};

export default DealDetail;
